// vms-find-mounts-mcp.js: WebMCP tool vms-mounts-for-tv for the find-mounts page. Notes: assets/vms-find-mounts.notes.md
(function () {
  'use strict';

  var VMS_PAGE_TOOLS = (typeof window !== 'undefined' && window)
    ? (window.VMSPageTools = window.VMSPageTools || { version: 1, tools: [] })
    : null;
  if (VMS_PAGE_TOOLS && !VMS_PAGE_TOOLS.register) {
    VMS_PAGE_TOOLS.register = function (tool) {
      if (!tool || typeof tool.name !== 'string') return;
      var idx = -1;
      for (var i = 0; i < VMS_PAGE_TOOLS.tools.length; i++) { if (VMS_PAGE_TOOLS.tools[i].name === tool.name) { idx = i; break; } }
      if (idx >= 0) VMS_PAGE_TOOLS.tools[idx] = tool; else VMS_PAGE_TOOLS.tools.push(tool);
      try { document.dispatchEvent(new CustomEvent('vms:page-tools-changed')); } catch (e) { }
    };
    VMS_PAGE_TOOLS.unregister = function (name) {
      var before = VMS_PAGE_TOOLS.tools.length;
      var kept = [];
      for (var i = 0; i < VMS_PAGE_TOOLS.tools.length; i++) { if (VMS_PAGE_TOOLS.tools[i].name !== name) kept.push(VMS_PAGE_TOOLS.tools[i]); }
      VMS_PAGE_TOOLS.tools = kept;
      if (VMS_PAGE_TOOLS.tools.length !== before) { try { document.dispatchEvent(new CustomEvent('vms:page-tools-changed')); } catch (e) { } }
    };
    VMS_PAGE_TOOLS.list = function () { return VMS_PAGE_TOOLS.tools.slice(); };
  }

  var ORIGIN = 'https://videomountstore.com';
  var PAGE = '/pages/find-mounts-by-tv-model';
  var INCLUDE = ['ceiling', 'wall', 'two_tv'];

  function textResult(payload) { return { content: [{ type: 'text', text: typeof payload === 'string' ? payload : JSON.stringify(payload) }] }; }
  function errMessage(e) { return (e && e.message) ? e.message : 'This tool could not run right now.'; }
  function adaptExecute(t) {
    return function (input) {
      try {
        var out = t.execute(input);
        if (out && typeof out.then === 'function') { return out.then(function (r) { return r; }, function (e) { return textResult(errMessage(e)); }); }
        return out;
      } catch (e) { return textResult(errMessage(e)); }
    };
  }
  function unknownKeys(args, allowed) {
    var extra = [];
    if (args && typeof args === 'object') { for (var k in args) { if (Object.prototype.hasOwnProperty.call(args, k) && allowed.indexOf(k) === -1) extra.push(k); } }
    return extra;
  }
  function absUrl(u) { return (typeof u === 'string' && u.indexOf('/') === 0 && u.indexOf('//') !== 0) ? ORIGIN + u : u; }
  function absImg(u) { return (typeof u === 'string' && u.indexOf('//') === 0) ? 'https:' + u : absUrl(u); }

  var parsed;
  function data(F) {
    var w = F.expand(window.VMSFindMountsData);
    if (w) return w;
    if (parsed) return parsed;
    try {
      var doc = window.document || (typeof document !== 'undefined' ? document : null);
      var el = doc && doc.getElementById ? doc.getElementById('vms-find-mounts-data') : null;
      parsed = el ? F.expand(JSON.parse(el.textContent || '')) : null;
    } catch (e) { parsed = null; }
    return parsed;
  }
  function cfg(d) { return d && d.page_config && typeof d.page_config === 'object' ? d.page_config : {}; }
  function endpoint(d) {
    var doc = window.document, el = doc && doc.querySelector ? doc.querySelector('[data-vms-tvl]') : null;
    return (el && el.getAttribute('data-endpoint')) || cfg(d).endpoint || '/apps/toolkit/tv-lookup';
  }

  function sid() {
    var S = window.VMSSavedTv, T = window.VMSTvLookup, s = S && typeof S.sid === 'function' ? S.sid() : (T && typeof T.sid === 'function' ? T.sid() : '');
    return /^[0-9a-f]{16}$/.test(s || '') ? '&sid=' + s : '';
  }
  function fetchRow(d, model) {
    var url = endpoint(d);
    url += (url.indexOf('?') === -1 ? '?' : '&') + 'q=' + encodeURIComponent(model) + sid();
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 8000) : null;
    function done() { if (timer) clearTimeout(timer); }
    return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (res) {
        if (res.status === 400) return { match: 'none', rows: [] };
        if (!res.ok) throw new Error('status');
        return res.json();
      })
      .then(function (body) { done(); return body || { match: 'none', rows: [] }; },
        function () { done(); throw new Error('The TV list is not answering right now.'); });
  }

  function vesaOut(tv) { return tv.vesaW != null && tv.vesaH != null ? tv.vesaW + 'x' + tv.vesaH : null; }
  function pageUrl(F, tv) {
    var p = F.pageParams(tv).map(function (kv) { return kv[0] + '=' + encodeURIComponent(kv[1]); }).join('&');
    return ORIGIN + PAGE + (p ? '?' + p : '');
  }

  function okOnly(c) { return { vesa: c.vesa.ok, weight: c.weight.ok, size: c.size.ok }; }
  function railsOut(F, tv, r) {
    var x = r.rails;
    return { needed: x.needed, included_free: x.needed === false ? null : x.free, top_edge_to_lower_holes_mm: x.total_mm, top_edge_to_lower_holes_in: x.total_in, reach_mm: x.reach_mm, max_screen_in: x.max_in,
      why: F.copy.railsLine(r), adapter_url: x.needed === false || x.free === true ? null : absUrl(F.railsUrl(tv)) };
  }

  function shapeOut(F, tv, d, include, withExcluded) {
    var res = F.matchAll(tv, d, { builderUrl: cfg(d).builder_url });
    var one = function (r) {
      var m = r.mount;
      var o = { handle: m.handle, title: m.title, url: absUrl(m.url), price: m.price, price_max: m.price_max == null ? null : m.price_max,
        group: r.group, sub: r.sub, fit: r.fit, checks: okOnly(r.checks), lines: F.copy.lines(r) };
      if (r.rails) o.rails = railsOut(F, tv, r);
      return o;
    };
    var matches = [];
    if (include.indexOf('ceiling') !== -1) matches = matches.concat(res.groups.ceiling.map(one));
    if (include.indexOf('wall') !== -1) matches = matches.concat(res.groups.wall.map(one));
    var st = res.state;
    var out = {
      state: st,
      tv: { model: tv.model, manufacturer: tv.manufacturer, screen_size_in: tv.sizeIn, vesa: vesaOut(tv), weight_lb: tv.weightLb == null ? null : Math.round(tv.weightLb * 10) / 10, source: tv.source, catalog_version: tv.catalogVersion },
      sentence: F.copy.sentence(res),
      two_tv_note: F.copy.twoTvNote(res),
      answer: (st === 'proprietary' || st === 'no_vesa' || st === 'zero' || st === 'need_size') ? F.copy.answer(st, res, cfg(d).phone) : null,
      zero_reason: st === 'zero' ? res.zeroReason : null,
      counts: res.counts,
      matches: matches
    };
    if (include.indexOf('two_tv') !== -1) out.two_tv = res.groups.two_tv.map(one);
    out.excluded_count = res.excluded.length;
    if (withExcluded) out.excluded = res.excluded;
    out.builder_url = res.builder.show ? absUrl(res.builder.url) : null;
    out.page_url = pageUrl(F, tv);
    return out;
  }

  function execute(args) {
    var a = args && typeof args === 'object' ? args : {};
    var extra = unknownKeys(a, ['model', 'screen_size_in', 'vesa', 'weight_lb', 'include', 'include_excluded']);
    if (extra.length) throw new Error('Unknown input: ' + extra.join(', ') + '. Accepted: model, screen_size_in, vesa, weight_lb, include, include_excluded.');
    if (a.include_excluded != null && typeof a.include_excluded !== 'boolean') throw new Error('include_excluded must be true or false.');
    var F = window.VMSMountFit, d = F && data(F);
    if (!F || !d) throw new Error('The mount data is not on this page.');
    var model = typeof a.model === 'string' ? a.model.trim() : null;
    if (a.model != null && (!model || model.length > 64)) throw new Error('model must be 1 to 64 characters.');
    var size = null;
    if (a.screen_size_in != null) {
      size = Number(a.screen_size_in);
      if (!(typeof a.screen_size_in === 'number' && Math.floor(size) === size && size >= 10 && size <= 90)) throw new Error('screen_size_in must be a whole number from 10 to 90.');
    }
    var v = null;
    if (a.vesa != null) { v = F.parseVesa(a.vesa); if (!v) throw new Error('vesa must be two numbers in mm joined by x, for example 400x300.'); }
    var wlb = null;
    if (a.weight_lb != null) { wlb = a.weight_lb; if (!(typeof wlb === 'number' && isFinite(wlb) && wlb > 0)) throw new Error('weight_lb must be a number over 0.'); }
    var include = ['ceiling', 'wall'];
    if (a.include != null) {
      if (!Array.isArray(a.include) || a.include.some(function (x) { return INCLUDE.indexOf(x) === -1; })) throw new Error('include must be a list of ceiling, wall and two_tv.');
      include = a.include;
    }
    function apply(tv) {
      if (v) { tv.vesaW = v.w; tv.vesaH = v.h; if (tv.state === 'no_vesa') tv.state = 'ok'; }
      if (wlb != null) { tv.weightLb = wlb; tv.weightKg = null; }
      return shapeOut(F, tv, d, include, a.include_excluded === true);
    }
    if (model) {
      return fetchRow(d, model).then(function (body) {
        var rows = Array.isArray(body.rows) ? body.rows : [], m = body.match;
        if (m === 'suggestion' || (m === 'alias' && rows.length > 1)) {
          return textResult({ state: m === 'suggestion' ? 'suggestion' : 'choose', query: model, models: rows.slice(0, 8).map(function (r) { return r.model_number; }), page_url: ORIGIN + PAGE + '?q=' + encodeURIComponent(model) });
        }
        if (!rows.length || (m !== 'exact' && m !== 'merged' && m !== 'alias')) return textResult({ state: 'none', query: model, answer: F.copy.answer('none', null, cfg(d).phone) });
        return textResult(apply(F.tvFromRow(rows[0], { size: size, catalogVersion: body.catalog_version })));
      });
    }
    var tv = F.tvFromParams({ size: size, vesa: v ? v.w + 'x' + v.h : null });
    if (!tv) throw new Error('Pass a model number, or the screen size and the VESA pattern.');
    return Promise.resolve(textResult(apply(tv)));
  }

  var tool = {
    name: 'vms-mounts-for-tv',
    description: 'List every ceiling and wall mount we sell that fits one TV, with the numbers behind each fit. Pass the TV\'s model number, or its screen size and VESA pattern. Checks hole pattern, weight and screen size. Never lists head-only parts; two-TV mounts come back only when asked. A 33FD001 match has a rails object: if rails.needed is true it needs adapter rails, whatever fit says. Returns counts by type, check lines and a builder link. include_excluded adds why the rest failed. Read-only.',
    readOnlyHint: true,
    annotations: { readOnlyHint: true, openWorldHint: false },
    inputSchema: {
      type: 'object',
      additionalProperties: false,
      properties: {
        model: { type: 'string', minLength: 1, maxLength: 64, description: 'The TV model number as printed on the label, for example QN65QN80HAFXZA.' },
        screen_size_in: { type: 'integer', minimum: 10, maximum: 90, description: 'Screen size in inches. Overrides the size on file for the model.' },
        vesa: { type: 'string', description: 'VESA hole pattern in mm, width x height, for example 400x300.' },
        weight_lb: { type: 'number', exclusiveMinimum: 0, description: 'TV weight in lb. Overrides the weight on file for the model.' },
        include: { type: 'array', items: { type: 'string', enum: INCLUDE }, description: 'Which groups to return. Default ceiling and wall; add two_tv for two-TV mounts.' },
        include_excluded: { type: 'boolean', description: 'Also return each mount that does not fit, with the first rule it failed. Default false.' }
      }
    },
    execute: execute
  };
  var tools = [tool];

  if (VMS_PAGE_TOOLS) VMS_PAGE_TOOLS.register(tool);

  var attachedTargets = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  function attach(mc) {
    if (!mc || typeof mc.registerTool !== 'function') return 0;
    if (attachedTargets && attachedTargets.has(mc)) return 0;
    var n = 0;
    tools.forEach(function (t) {
      try {
        mc.registerTool({ name: t.name, description: t.description, inputSchema: t.inputSchema, annotations: t.annotations, readOnlyHint: true, execute: adaptExecute(t) });
        n++;
      } catch (e) {}
    });
    if (n > 0 && attachedTargets) attachedTargets.add(mc);
    return n;
  }

  window.VMSFindMountsMCP = { tools: tools, attach: attach };

  var done = false;
  function currentMC() {
    var d = window.document, nv = window.navigator;
    return (d && d.modelContext) || (nv && nv.modelContext) || null;
  }
  function tryAttach() {
    if (done) return true;
    var secure = typeof window.isSecureContext === 'undefined' ? true : !!window.isSecureContext;
    if (window.top !== window.self || !secure) { done = true; return true; }
    var mc = currentMC();
    if (!mc || typeof mc.registerTool !== 'function') return false;
    attach(mc);
    done = true;
    return true;
  }
  try {
    if (!tryAttach()) {
      var again = function () { tryAttach(); };
      if (window.document && window.document.addEventListener) window.document.addEventListener('DOMContentLoaded', again);
      if (window.addEventListener) window.addEventListener('load', again);
      var waits = [500, 500, 1000, 2000, 4000, 8000, 15000];
      var step = function (i) {
        if (done || i >= waits.length || typeof window.setTimeout !== 'function') return;
        window.setTimeout(function () { if (!tryAttach()) step(i + 1); }, waits[i]);
      };
      step(0);
    }
  } catch (e) {}
})();
